<span class="!text-error" matDialogTitle>
  {{ data.title }}
</span>
<button mat-icon-button matDialogClose (click)="close()">
  <mat-icon> close </mat-icon>
</button>

<mat-dialog-content>
  @if (data.showMessage) {
    {{ data.message }}
  }
  <div
    class="flex items-center justify-center w-full"
    (click)="copyMessageToClipboard()"
  >
    <div>{{ 'Copia codice errore' | siaTranslate }}</div>
    <button mat-icon-button>
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
  <!-- <div class="flex justify-start w-full">
    <span>{{ data.requestUrl }}</span>
  </div> -->
</mat-dialog-content>

<div matDialogActions align="end" class="gap-2">
  @if (emailString) {
    <a
      [href]="emailString"
      target="_top"
      class="text-xs underline md:no-underline"
    >
      <span>{{ 'Contatta supporto' | siaTranslate }}</span>
    </a>
  }
  <button mat-button (click)="close()" [autofocus]="true" class="button-grey">
    {{ 'Chiudi' | siaTranslate }}
  </button>
</div>
